import { combineEpics } from "redux-observable";
import productAlertFetch from "./product-alert-fetch";

export default combineEpics(productAlertFetch);
